import React, { useEffect, useState } from "react";
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import Pusher from "pusher-js";
import axios from "axios";
import "./NotificationBell.css"; // For custom styling
import wrongimage from "../../Assets/images/wrongimg.jpg";
import configServ from "../../../services/config";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
  rSetSalesOrderData,
  rSetSalesSearchByName,
  rSetUnregisterPaymentSearchData,
  rSetleadSearchData,
  rSetleadSearchDataValue,
} from "../../../redux/reducers/GlobalVariables";
import LoaderBackdrop from "../../Loader/LoaderBackdrop";
// import { refreshSalesOrder } from "../.././Card/SalesOrderCards/SalesOrderTable";
const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    right: 5,
    top: 13,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: "0 4px",
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const NotificationBell = () => {
  const [notifications, setNotifications] = useState([]);
  const location = useLocation();
  const [unreadCount, setUnreadCount] = useState(0);
  const [isShaking, setIsShaking] = useState(false);
  const [bellColor, setBellColor] = useState("inherit");
  const navigate = useNavigate(); // Initialize navigate function
  const {
    user_id,
    company_id,
    companyName,
    is_super,
    is_admin,
    adminId,
    staff,
  } = useSelector((state) => state.GlobalVariables);
  const dispatch = useDispatch();
  const [openBackdrop, setOpenBackdrop] = useState(false);

  // console.log("adminId:", adminId);
  // console.log("userCompanyId:", company_id);
  // console.log("userId:", user_id);
  // console.log("Stff:", staff);

  let entityId, entityType;

  if (is_admin) {
    entityId = adminId;
    entityType = "Admin";
  } else if (staff) {
    entityId = user_id;
    entityType = "Staff";
  } else {
    entityId = user_id;
    entityType = "Customer";
  }

  // console.log(company_id, is_admin);
  const [open, setOpen] = useState(false); // State to control dialog open/close
  // const userRole = "admin"; // Retrieve role from session storage
  const userCompanyId = company_id; // Retrieve company ID from session storage

  // Function to fetch unread notifications from the backend
  const fetchUnreadNotifications = async () => {
    try {
      const response = await configServ.showUnreadNotifications({
        user_id: entityId,
        entity_type: entityType,
      });
      console.log("response=", response);
      if (response.success) {
        // Filter notifications by company_id
        const filteredNotifications = response.data.filter(
          (notification) => notification.company_id === parseInt(userCompanyId)
        );
        setNotifications(filteredNotifications);
        setUnreadCount(filteredNotifications.length);
      } else {
        console.error("Failed to fetch notifications:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching unread notifications:", error);
    }
  };

  useEffect(() => {
    // Run only if the user is an admin
    if (userCompanyId) {
      // Fetch unread notifications when the component loads
      fetchUnreadNotifications();

      // Initialize Pusher client
      const pusher = new Pusher("4ac9eb20937db28eeb9b", {
        cluster: "ap2",
        forceTLS: true,
      });

      // Subscribe to the unregister-payment channel
      const unregisterPaymentChannel = pusher.subscribe(
        `unregister-payment.${entityId}.${userCompanyId}`
      );
      unregisterPaymentChannel.bind(
        "App\\Events\\UnregisterPaymentCreated",
        (data) => {
          console.log("Unregister-payment notification received:", data);

          if (data.company_id === parseInt(userCompanyId)) {
            setNotifications((prevNotifications) => [
              ...prevNotifications,
              {
                message: data.message,
                read_at: null,
                type: data.type,
                entity_search: data.entity_search,
                id: data.id,
              },
            ]);
            setUnreadCount((prevCount) => prevCount + 1);
            setBellColor("error");
            setIsShaking(true);
          }
        }
      );

      // Subscribe to the create-order channel
      console.log("create order", entityId, userCompanyId);
      const createOrderChannel = pusher.subscribe(
        `create-order.${entityId}.${userCompanyId}`
      );
      createOrderChannel.bind(
        "App\\Events\\CreateOrderNotification",
        (data) => {
          console.log("Create-order notification received:", data);

          if (data.company_id === parseInt(userCompanyId)) {
            setNotifications((prevNotifications) => [
              ...prevNotifications,
              {
                message: data.message,
                entity_search: data.entity_search,
                read_at: null,
                type: data.type,
                id: data.id,
              },
            ]);
            setUnreadCount((prevCount) => prevCount + 1);
            setBellColor("error");
            setIsShaking(true);
          }
        }
      );

      // Subscribe to the approved payments channel {UnregisterPaymentApprovedCustomerSide}
      const createpaymentApproved = pusher.subscribe(
        `payment-approved.${entityId}.${userCompanyId}`
      );
      createpaymentApproved.bind(
        "App\\Events\\UnregisterPaymentApprovedCustomerSide",
        (data) => {
          console.log(
            "UnregisterPaymentApprovedCustomerSide notification received:",
            data
          );

          if (data.company_id === parseInt(userCompanyId)) {
            setNotifications((prevNotifications) => [
              ...prevNotifications,
              {
                message: data.message,
                entity_search: data.entity_search,
                read_at: null,
                type: data.type,
                id: data.id,
              },
            ]);
            setUnreadCount((prevCount) => prevCount + 1);
            setBellColor("error");
            setIsShaking(true);
          }
        }
      );

      // Subscribe to the leads channel
      const createLeadChannel = pusher.subscribe(
        `lead.${entityId}.${userCompanyId}`
      );
      createLeadChannel.bind("App\\Events\\CreateLeadNotifications", (data) => {
        console.log("CreateLeadNotifications notification received:", data);

        if (data.company_id === parseInt(userCompanyId)) {
          setNotifications((prevNotifications) => [
            ...prevNotifications,
            {
              message: data.message,
              entity_search: data.entity_search,
              read_at: null,
              type: data.type,
              id: data.id,
            },
          ]);
          setUnreadCount((prevCount) => prevCount + 1);
          setBellColor("error");
          setIsShaking(true);
        }
      });

      // Subscribe to the Approved - payments channel
      const createApprovedPaymentsChannel = pusher.subscribe(
        `approved-sales-payment.${entityId}.${userCompanyId}`
      );
      createApprovedPaymentsChannel.bind(
        "App\\Events\\ApprovedSalesOrder",
        (data) => {
          console.log("ApprovedSalesOrder notification received:", data);
          if (data.company_id === parseInt(userCompanyId)) {
            setNotifications((prevNotifications) => [
              ...prevNotifications,
              {
                message: data.message,
                entity_search: data.entity_search,
                read_at: null,
                type: data.type,
                id: data.id,
              },
            ]);
            setUnreadCount((prevCount) => prevCount + 1);
            setBellColor("error");
            setIsShaking(true);
          }
        }
      );

      // Subscribe to the Create invoice channel
      const createInvoiceChannel = pusher.subscribe(
        `new-invoice.${entityId}.${userCompanyId}`
      );
      createInvoiceChannel.bind(
        "App\\Events\\InvoiceCreateNotification",
        (data) => {
          console.log("InvoiceCreateNotification notification received:", data);
          if (data.company_id === parseInt(userCompanyId)) {
            setNotifications((prevNotifications) => [
              ...prevNotifications,
              {
                message: data.message,
                entity_search: data.entity_search,
                read_at: null,
                type: data.type,
                id: data.id,
              },
            ]);
            setUnreadCount((prevCount) => prevCount + 1);
            setBellColor("error");
            setIsShaking(true);
          }
        }
      );

      // Subscribe to the Create dispatch channel
      const createDispatchChannel = pusher.subscribe(
        `new-dispatch.${entityId}.${userCompanyId}`
      );
      createDispatchChannel.bind(
        "App\\Events\\DispatchNotification",
        (data) => {
          console.log("DispatchNotification notification received:", data);
          if (data.company_id === parseInt(userCompanyId)) {
            setNotifications((prevNotifications) => [
              ...prevNotifications,
              {
                message: data.message,
                entity_search: data.entity_search,
                read_at: null,
                type: data.type,
                id: data.id,
              },
            ]);
            setUnreadCount((prevCount) => prevCount + 1);
            setBellColor("error");
            setIsShaking(true);
          }
        }
      );

       // Subscribe to the Create dispatch channel
       const createApprovedMesgToStaff = pusher.subscribe(
        `approved-sales-payment-staff-notification.${entityId}.${userCompanyId}`
      );
      createApprovedMesgToStaff.bind(
        "App\\Events\\ApprovedSalesOrderMesgInStaff",
        (data) => {
          console.log("createApprovedMesgToStaff notification received:", data);
          if (data.company_id === parseInt(userCompanyId)) {
            setNotifications((prevNotifications) => [
              ...prevNotifications,
              {
                message: data.message,
                entity_search: data.entity_search,
                read_at: null,
                type: data.type,
                id: data.id,
              },
            ]);
            setUnreadCount((prevCount) => prevCount + 1);
            setBellColor("error");
            setIsShaking(true);
          }
        }
      );

       // Subscribe to the Create order notification when created by admin and staff channel
       const createOrderNotfForCustomer = pusher.subscribe(
        `create-order-noti-for-customer.${entityId}.${userCompanyId}`
      );
      createOrderNotfForCustomer.bind(
        "App\\Events\\CreateOrderNotifToCustomer",
        (data) => {
          console.log("CreateOrderNotifToCustomer notification received:", data);
          if (data.company_id === parseInt(userCompanyId)) {
            setNotifications((prevNotifications) => [
              ...prevNotifications,
              {
                message: data.message,
                entity_search: data.entity_search,
                read_at: null,
                type: data.type,
                id: data.id,
              },
            ]);
            setUnreadCount((prevCount) => prevCount + 1);
            setBellColor("error");
            setIsShaking(true);
          }
        }
      );

      // Cleanup: Unsubscribe from the channels when the component unmounts
      return () => {
        pusher.unsubscribe(`unregister-payment.${entityId}.${userCompanyId}`);
        pusher.unsubscribe(`create-order.${entityId}.${userCompanyId}`);
        pusher.unsubscribe(`payment-approved.${entityId}.${userCompanyId}`);
        pusher.unsubscribe(`lead.${entityId}.${userCompanyId}`);
        pusher.unsubscribe(
          `approved-sales-payment.${entityId}.${userCompanyId}`
        );
        pusher.unsubscribe(`new-invoice.${entityId}.${userCompanyId}`);
        pusher.unsubscribe(`new-dispatch.${entityId}.${userCompanyId}`);
        pusher.unsubscribe(`approved-sales-payment-staff-notification.${entityId}.${userCompanyId}`);
        pusher.unsubscribe(`create-order-noti-for-customer.${entityId}.${userCompanyId}`);


      };
    }
  }, [userCompanyId]); // Dependencies: Only run when these values change

  // Handle bell click
  const handleBellClick = () => {
    setIsShaking(false); // Stop shake animation
    setBellColor("inherit"); // Reset bell color
    setUnreadCount(0); // Mark notifications as read
    setOpen(true); // Open the dialog
  };

  // Handle closing the dialog
  const handleClose = () => {
    setOpen(false); // Close dialog
  };

  // if (!is_admin) {
  //   return <p>Access denied</p>; // Render access denial message for non-admin users
  // }

  const handleNotificationClick = async (notification) => {
    setOpen(false);
    // console.log(notification)
    try {
      setOpenBackdrop(true);
      const dataToSend = {
        id: notification.id,
      };
      const response = await configServ.markNotificationAsRead(dataToSend); // API call with notification ID
      if (response.success) {
        // alert(`Notification for ${notification.type} marked as read.`);
        fetchUnreadNotifications();
        const isOnSalesOrderPage = location.pathname === "/sales-order";
        const isOnUnregisterPage = location.pathname === "/unregister-payment";
        const isOnLeadPage =  location.pathname === "/account-master-entry/leads";

        // Perform any additional action based on the notification type
        if (notification.type === "New Order") {
          if (isOnSalesOrderPage) {
            dispatch(rSetSalesOrderData(notification.entity_search));
            dispatch(rSetSalesSearchByName("order_no"));
          } else {
            // Navigate to the sales-order page with the data
            navigate("/sales-order", {
              state: {
                searchByName: "order_no",
                orderData: notification.entity_search,
              },
            });
          }
          // Add custom logic for 'New Order' if needed
        } else if (notification.type === "unregister payments") {
          console.log("Handling Unregister Payments notification...");
          if (isOnUnregisterPage) {
            dispatch(
              rSetUnregisterPaymentSearchData(notification.entity_search)
            );
          } else {
            // Navigate to the unregister-payment page with the data
            navigate("/unregister-payment", {
              state: {
                searchData: notification.entity_search,
              },
            });
          }
        } else if (notification.type === "New Leads") {
          console.log("Handling leads Payments notification...");
          if (isOnLeadPage) {
            dispatch(rSetleadSearchData(notification.mobile_no));
            dispatch(rSetleadSearchDataValue("mobile"));
          } else {
            // Navigate to the unregister-payment page with the data
            navigate("/account-master-entry/leads", {
              state: {
                searchByvalue: "mobile",
                searchData: notification.mobile_no,
              },
            });
          }
        } else {
          console.log(`Handling ${notification.type} notification...`);
          // Add a generic or default action for other types if needed
        }
      } else {
        console.error("Failed to mark notification as read:", response.message);
      }
    } catch (error) {
      console.error("Error marking notification as read:", error);
    } finally {
      // Hide loading indicator
      setOpenBackdrop(false);
    }
  };

  return (
    <>
      <LoaderBackdrop open={openBackdrop} />
      <IconButton
        color={bellColor}
        onClick={handleBellClick}
        className={isShaking ? "shake" : ""}
      >
        <StyledBadge badgeContent={unreadCount} color="error">
          <NotificationsIcon />
        </StyledBadge>
      </IconButton>

      {/* Dialog Box for Notifications */}
      <Dialog
        open={open}
        TransitionComponent={Transition}
        onClose={handleClose}
        fullWidth
        maxWidth="xs"
        PaperProps={{
          sx: {
            position: "fixed",
            right: 0,
            top: "60px",
            m: 0,
            width: "100%",
            maxWidth: "320px",
            maxHeight: "80vh",
            borderRadius: "10px",
            zIndex: 2, // Lowered z-index value
          },
        }}
      >
        <DialogTitle>
          Notifications
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <img
              onClick={handleClose}
              src={wrongimage}
              alt="Close"
              style={{ height: "24px", width: "24px" }}
            />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ paddingBottom: "50px" }}>
          {notifications.map((notification, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "flex-start",
                padding: "15px",
                margin: "8px 0",
                borderRadius: "10px",
                border: "1px solid #ccc",
                backgroundColor: notification.read_at ? "#ffffff" : "#e0f7fa", // Light blue for unread, white for read
                transition: "background-color 0.3s ease",
                width: "100%", // Ensure full width
                cursor: "pointer", // Indicate the item is clickable
              }}
              onClick={() => handleNotificationClick(notification)}
            >
              <p
                style={{
                  margin: "0 0 5px",
                  fontSize: "12px",
                  fontWeight: "bold",
                  color: "#555",
                }}
              >
                Type: {notification.type}
              </p>
              <p
                style={{
                  margin: "0 0 10px",
                  fontSize: "14px",
                  fontWeight: "bold",
                }}
              >
                {notification.message && <p> {notification.message}</p>}
              </p>
            </div>
          ))}
        </DialogContent>
        {/* <div
          style={{
            padding: "10px 15px",
            position: "absolute",
            bottom: 0,
            width: "100%",
            borderTop: "1px solid #ccc",
            backgroundColor: "#f9f9f9",
            textAlign: "center",
          }}
        >
          <button
            style={{
              padding: "8px 20px",
              fontSize: "14px",
              borderRadius: "5px",
              border: "none",
              backgroundColor: "#007bff",
              color: "white",
              cursor: "pointer",
            }}
            onClick={() => {
              console.log("Mark all as read";
              // Add your "read all" functionality here
            }}
          >
            Read All
          </button>
        </div> */}
      </Dialog>
    </>
  );
};

export default NotificationBell;
